import React from 'react';

import styles from './GreenCardNum.module.css';


function GreenCardNum(props) {
  const { num } = props;

  return (
    <div className={styles.greenCard}>
      <div className={styles.bg}></div>
      <div className={styles.greenNum}>{num}</div>
    </div>
  );
}

export default GreenCardNum;
